<template>
  <div :class="prefixCls">
    <Image.PreviewGroup>
      <slot v-if="!imageList || $slots.default"></slot>
      <template v-else>
        <template v-for="item in getImageList" :key="item.src">
          <Image v-bind="item">
            <template v-if="typeof item.placeholder === 'string'" #placeholder>
              <Image v-bind="item" :src="item.placeholder" :preview="false" />
            </template>
          </Image>
        </template>
      </template>
    </Image.PreviewGroup>
  </div>
</template>

<script lang="ts" setup>
  import { Image } from 'ant-design-vue';
  import { computed } from 'vue';
  import { isString } from '@mts-fe/utils';
  import { useDesign } from '@mts/hooks/web/useDesign';

  interface ImageProps {
    alt?: string;
    fallback?: string;
    src: string;
    width: string | number;
    height?: string | number;
    placeholder?: string | boolean;
    preview?:
      | boolean
      | {
          visible?: boolean;
          onVisibleChange?: (visible: boolean, prevVisible: boolean) => void;
          getContainer: string | HTMLElement | (() => HTMLElement);
        };
  }

  defineOptions({ name: 'PreviewImage' });

  const props = withDefaults(defineProps<{ imageList: string[] | ImageProps[] }>(), {
    imageList: () => [],
  });

  const { prefixCls } = useDesign('preview-image');

  const getImageList = computed(() =>
    props.imageList
      .filter((i) => i)
      .map((url) =>
        isString(url)
          ? { src: url.startsWith('minio/') ? '/' + url : url, placeholder: false }
          : url,
      ),
  );
</script>
<style lang="less">
  @prefix-cls: ~'@{namespace}-preview-image';

  .@{prefix-cls} {
    display: inline-flex;
    gap: 8px;
  }
</style>
